module.exports = __webpack_public_path__ + "img/soft-grove-bathroom-4.1a577da2.jpeg";